import React, { useState, useEffect } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import './App.css';

function Liquidacion() {
  const [empleados, setEmpleados] = useState([]);
  const [fichajes, setFichajes] = useState([]);
  
  const hoy = new Date();
  const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1).toISOString().split('T')[0];
  const ultimoDiaMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0).toISOString().split('T')[0];

  const [fechaInicio, setFechaInicio] = useState(primerDiaMes);
  const [fechaFin, setFechaFin] = useState(ultimoDiaMes);
  const [filtroEmpleado, setFiltroEmpleado] = useState(''); // NUEVO: Filtro por empleado

  useEffect(() => {
    fetchDatos();
  }, []);

  const fetchDatos = async () => {
    try {
      const resEmp = await fetch('/api/empleados');
      const dataEmp = await resEmp.json();
      setEmpleados(dataEmp);

      const resFich = await fetch('/api/fichajes');
      const dataFich = await resFich.json();
      setFichajes(dataFich);
    } catch (error) {
      console.error('Error cargando datos:', error);
    }
  };

  // --- NUEVO MOTOR MATEMÁTICO: JORNALES, EXTRAS Y DESCUENTOS ---
  const generarReporte = () => {
    // 1. Filtrar los fichajes por el rango de fechas
    const fichajesRango = fichajes.filter(f => {
      const fecha = new Date(f.fecha_hora);
      const inicio = new Date(fechaInicio); inicio.setHours(0,0,0,0);
      const fin = new Date(fechaFin); fin.setHours(23,59,59,999);
      return fecha >= inicio && fecha <= fin;
    });

    // 2. Ordenar cronológicamente
    const fichajesOrdenados = [...fichajesRango].sort((a, b) => new Date(a.fecha_hora) - new Date(b.fecha_hora));

    let empleadosFiltrados = empleados;
    if (filtroEmpleado) {
      empleadosFiltrados = empleados.filter(e => e.nombre === filtroEmpleado);
    }

    // 3. Calcular día por día para cada empleado
    const reporte = empleadosFiltrados.map(emp => {
      const misFichajes = fichajesOrdenados.filter(f => f.empleado_id === emp.id || f.nombre === emp.nombre);
      
      // Agrupamos los fichajes por día para aplicar la regla de 8 horas
      const fichajesPorDia = {};
      misFichajes.forEach(f => {
         const dia = new Date(f.fecha_hora).toLocaleDateString('es-UY');
         if(!fichajesPorDia[dia]) fichajesPorDia[dia] = [];
         fichajesPorDia[dia].push(f);
      });

      let horasNormales = 0;
      let horasExtras = 0;
      let horasDescontadas = 0;

      Object.keys(fichajesPorDia).forEach(dia => {
         const punches = fichajesPorDia[dia];
         let entrada = null, inicioDesc = null, finDesc = null, salida = null;
         
         punches.forEach(p => {
             if(p.tipo_fichaje === 'Entrada') entrada = new Date(p.fecha_hora);
             if(p.tipo_fichaje === 'Inicio Descanso') inicioDesc = new Date(p.fecha_hora);
             if(p.tipo_fichaje === 'Fin Descanso') finDesc = new Date(p.fecha_hora);
             if(p.tipo_fichaje === 'Salida') salida = new Date(p.fecha_hora);
         });

         // Si el empleado completó su ciclo de fichaje en el día
         if(entrada && salida) {
             const tiempoFisicoMilisegundos = (salida - entrada);
             const tiempoFisicoHoras = tiempoFisicoMilisegundos / (1000 * 60 * 60);
             
             let tiempoDescansoHoras = 0;
             if(inicioDesc && finDesc) {
                 tiempoDescansoHoras = (finDesc - inicioDesc) / (1000 * 60 * 60);
             }

             // REGLA: Los primeros 30 minutos (0.5 hrs) no se descuentan.
             let descuentoPorDescanso = 0;
             if(tiempoDescansoHoras > 0.5) {
                 descuentoPorDescanso = tiempoDescansoHoras - 0.5;
             }

             // Horas reales a pagar en el día
             let horasPagasDia = tiempoFisicoHoras - descuentoPorDescanso;
             
             // REGLA: Jornal completo es de 8 horas. Todo lo que supere es Extra.
             if(horasPagasDia > 8) {
                 horasNormales += 8;
                 horasExtras += (horasPagasDia - 8);
             } else {
                 horasNormales += horasPagasDia;
             }
             
             horasDescontadas += descuentoPorDescanso;
         }
      });

      const valorHora = parseFloat(emp.valor_hora) || 0;
      const subtotalNormal = horasNormales * valorHora;
      const subtotalExtra = horasExtras * valorHora; // Si pagas extra doble, multiplica esto * 2
      const totalPagar = subtotalNormal + subtotalExtra;

      return {
        ...emp,
        horasNormales: horasNormales.toFixed(1),
        horasExtras: horasExtras.toFixed(1),
        horasDescontadas: horasDescontadas.toFixed(1),
        totalPagar: totalPagar.toFixed(2)
      };
    });

    return reporte;
  };

  const datosReporte = generarReporte();

  // Función temporal hasta que conectemos el generador PDF del servidor
  // --- MOTOR GRÁFICO PARA RECIBOS EN PDF ---
// --- MOTOR GRÁFICO PARA RECIBOS EN PDF (VERSIÓN SEGURA) ---
  const generarPDF = (empleado) => {
    try {
      const doc = new jsPDF();

      // 1. Cabecera (Logo y Nombre)
      doc.setFontSize(24);
      doc.setTextColor(3, 4, 94); // Azul oscuro corporativo
      doc.text('ASPE', 105, 20, { align: 'center' });

      doc.setFontSize(12);
      doc.setTextColor(85, 85, 85);
      doc.text('Acosta Silva Proeléctrica', 105, 28, { align: 'center' });
      
      doc.setFontSize(10);
      doc.text('Energía Inteligente & Excelencia Técnica', 105, 34, { align: 'center' });

      // Línea separadora
      doc.setDrawColor(0, 180, 216); // Cian corporativo
      doc.setLineWidth(1);
      doc.line(20, 38, 190, 38);

      // 2. Información del Empleado y Fechas
      const nombreLimpio = empleado.nombre || 'Empleado';
      const valorHoraNum = empleado.valor_hora ? parseFloat(empleado.valor_hora) : 0;

      doc.setFontSize(11);
      doc.setTextColor(51, 51, 51);
      doc.text(`Empleado: ${nombreLimpio}`, 20, 50);
      doc.text(`Cargo: ${empleado.cargo || 'No especificado'}`, 20, 58);
      doc.text(`Valor Hora (Base): $ ${valorHoraNum} UYU`, 20, 66);

      doc.text(`Periodo: ${fechaInicio} al ${fechaFin}`, 120, 50);
      doc.text(`Fecha de Emisión: ${new Date().toLocaleDateString('es-UY')}`, 120, 58);

      // 3. Tabla de Conceptos Matemáticos usando la importación directa
      autoTable(doc, {
        startY: 75,
        headStyles: { fillColor: [0, 180, 216] }, // Cabecera cian
        head: [['Concepto', 'Horas Computadas', 'Subtotal (UYU)']],
        body: [
          ['Jornales Normales (Base 8 hrs)', `${empleado.horasNormales || 0} hrs`, `$ ${(parseFloat(empleado.horasNormales || 0) * valorHoraNum).toFixed(2)}`],
          ['Horas Extras', `${empleado.horasExtras || 0} hrs`, `$ ${(parseFloat(empleado.horasExtras || 0) * valorHoraNum).toFixed(2)}`],
          ['Descuentos (Descansos > 30 min)', `- ${empleado.horasDescontadas || 0} hrs`, `- $ ${(parseFloat(empleado.horasDescontadas || 0) * valorHoraNum).toFixed(2)}`]
        ],
      });

      // 4. Total a Pagar
      const finalY = doc.lastAutoTable.finalY || 100;
      doc.setFontSize(14);
      doc.setTextColor(3, 4, 94);
      doc.text(`TOTAL A PAGAR: $ ${empleado.totalPagar || 0} UYU`, 190, finalY + 20, { align: 'right' });

      // 5. Firma de Conformidad
      doc.setDrawColor(51, 51, 51);
      doc.line(65, finalY + 60, 145, finalY + 60);
      doc.setFontSize(10);
      doc.setTextColor(51, 51, 51);
      doc.text('Firma del Empleado (Conforme)', 105, finalY + 66, { align: 'center' });

      // 6. Descargar el archivo
      doc.save(`Recibo_ASPE_${nombreLimpio.replace(/\s+/g, '_')}.pdf`);
      
    } catch (error) {
      // Si algo falla, ahora sí nos mostrará un cartel en rojo explicándonos el motivo.
      alert("Falla técnica al intentar generar el PDF: " + error.message);
      console.error(error);
    }
  };
  return (
    <div className="dashboard-pantalla">
      <header className="dashboard-header">
        <img src="/logo.png" alt="ASPE Logo" className="dashboard-logo" />
        <button onClick={() => window.location.href = '/dashboard'} className="btn-volver">Volver al Panel</button>
      </header>

      <main className="dashboard-main">
        <h2>💰 Liquidación y Jornales</h2>
        <p>Cálculo basado en base 8 horas con 30 min de descanso bonificado.</p>
        
        <div className="empleados-container" style={{ display: 'block' }}>
          {/* BARRA DE FILTROS AVANZADA */}
          <div className="filtros-bar" style={{ marginBottom: '20px' }}>
            <div className="filtro-grupo">
              <label>Periodo Desde:</label>
              <input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
            </div>
            <div className="filtro-grupo">
              <label>Periodo Hasta:</label>
              <input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
            </div>
            <div className="filtro-grupo" style={{ flex: 2 }}>
              <label>Filtrar por Empleado:</label>
              <select value={filtroEmpleado} onChange={(e) => setFiltroEmpleado(e.target.value)} style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc', width: '100%' }}>
                <option value="">-- Ver toda la nómina --</option>
                {empleados.map(emp => (
                  <option key={emp.id} value={emp.nombre}>{emp.nombre} ({emp.cargo})</option>
                ))}
              </select>
            </div>
          </div>

          <div className="empleados-lista">
            <h3>Reporte Detallado (UYU)</h3>
            <table className="tabla-aspe">
              <thead>
                <tr>
                  <th>Empleado</th>
                  <th>Hrs Normales</th>
                  <th>Hrs Extras</th>
                  <th>Descuentos</th>
                  <th>Total a Pagar</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {datosReporte.map(row => (
                  <tr key={row.id}>
                    <td><strong>{row.nombre}</strong><br/><small>$ {row.valor_hora}/hr</small></td>
                    <td style={{ color: '#17a2b8', fontWeight: 'bold' }}>{row.horasNormales} h</td>
                    <td style={{ color: '#ffc107', fontWeight: 'bold' }}>{row.horasExtras > 0 ? `+ ${row.horasExtras} h` : '-'}</td>
                    <td style={{ color: '#dc3545', fontWeight: 'bold' }}>{row.horasDescontadas > 0 ? `- ${row.horasDescontadas} h` : '-'}</td>
                    <td>
                      <span style={{ fontWeight: 'bold', color: row.totalPagar > 0 ? '#28a745' : '#6c757d', fontSize: '1.1rem' }}>
                        $ {row.totalPagar}
                      </span>
                    </td>
                    <td>
                        <button onClick={() => generarPDF(row)} style={{ padding: '6px 12px', backgroundColor: '#03045e', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                            📄 Crear Recibo
                        </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Liquidacion;